import React, { Fragment, useCallback } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Col, Row, Button, Form, FormGroup, Label } from 'reactstrap';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { useAuth } from '../../../Context/Auth/AuthContext';
import api from '../../../services/api';
import { toast } from 'react-toastify';

const schema = Yup.object().shape({
    email: Yup.string().email('Email invalid!').required('Email is required!'),
    code: Yup.string().required('Code is required'),
    password: Yup.string()
        .required('Password is required!')
        .min(6, 'Password must be at least 6 characters'),
    confirm_password: Yup.string()
        .required('Confirm password is required!')
        .oneOf([Yup.ref('password'), null], 'Passwords must match'),
});

export default function ForgotPassword() {
    const { register, errors, handleSubmit, reset } = useForm({
        validationSchema: schema,
    });
    const { toggleLoading } = useAuth();
    const history = useHistory();

    const onSubmit = useCallback((data) => {
        toggleLoading(true);
        api.post(`/ro.team.confirm-password`, {
            email: data.email,
            code: data.code,
            newPassword: data.password
        })
            .then((response) => {
                toast.success('Password recovered');
                reset(response);
                history.push('/');
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                toggleLoading(false);
            });
    }, [toggleLoading, reset, history]);
    return (
        <Fragment>
            <div className="h-100 bg-animation">
                <div className="d-flex h-100 justify-content-center align-items-center">
                    <Col md="6" className="mx-auto app-login-box">
                        <div className="app-logo-inverse mx-auto mb-3" />

                        <div className="modal-dialog w-100">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <div className="h5 modal-title">
                                        Recover password
                                        <h6 className="mt-1 mb-0 opacity-8">
                                            <span>
                                                Use the form below to recover your password.
                                            </span>
                                        </h6>
                                    </div>
                                </div>
                                <div className="modal-body">
                                    <div>
                                        <Form onSubmit={handleSubmit(onSubmit)}>
                                            <Row form>
                                                <Col md={12}>
                                                    <FormGroup>
                                                        <Label for="exampleEmail">
                                                            Email
                                                        </Label>
                                                        <input
                                                            type="email"
                                                            name="email"
                                                            id="exampleEmail"
                                                            placeholder="Email"
                                                            ref={register}
                                                            className="form-control"
                                                        />
                                                        {errors.email && (
                                                            <p className="error-validation">
                                                                {
                                                                    errors.email.message
                                                                }
                                                            </p>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                                <Col md={12}>
                                                    <FormGroup>
                                                        <Label for="code">
                                                            Confirmation Code
                                                        </Label>
                                                        <input
                                                            type="text"
                                                            name="code"
                                                            id="code"
                                                            placeholder="Code"
                                                            ref={register}
                                                            className="form-control"
                                                        />
                                                        {errors.code && (
                                                            <p className="error-validation">
                                                                {
                                                                    errors.code.message
                                                                }
                                                            </p>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                                <Col md={12}>
                                                    <FormGroup>
                                                        <Label for="password">
                                                            New password
                                                        </Label>
                                                        <input
                                                            type="password"
                                                            name="password"
                                                            id="password"
                                                            placeholder="Password"
                                                            ref={register}
                                                            className="form-control"
                                                        />
                                                        {errors.password && (
                                                            <p className="error-validation">
                                                                {
                                                                    errors.password.message
                                                                }
                                                            </p>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                                <Col md={12}>
                                                    <FormGroup>
                                                        <Label for="confirm_password">
                                                            Confirm new password
                                                        </Label>
                                                        <input
                                                            type="password"
                                                            name="confirm_password"
                                                            id="confirm_password"
                                                            placeholder="Confirm your New Password"
                                                            ref={register}
                                                            className="form-control"
                                                        />
                                                        {errors.confirm_password && (
                                                            <p className="error-validation">
                                                                {
                                                                    errors.confirm_password.message
                                                                }
                                                            </p>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </div>
                                    <div className="divider" />
                                    <h6 className="mb-0">
                                        <Link className="text-primary" to="/">
                                            Sign in existing account
                                        </Link>
                                    </h6>
                                </div>
                                <div className="modal-footer clearfix">
                                    <div className="float-right">
                                        <Button
                                            color="primary"
                                            size="lg"
                                            onClick={handleSubmit(onSubmit)}
                                        >
                                            Change Password
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="text-center text-white opacity-8 mt-3">
                            Copyright &copy; ArchitectUI 2019
                        </div> */}
                    </Col>
                </div>
            </div>
        </Fragment>
    );
}
